import {
  AccountBalanceOutlined,
  ApartmentOutlined,
  AttachFileOutlined,
  HistoryOutlined,
  TextSnippetOutlined,
} from "@mui/icons-material";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import { isEmpty, size } from "lodash";
import { useSelector } from "react-redux";
import Txt from "../../components/typography/Txt";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Screen from "../../components/layout/Screen";
import ScreenContent from "../../components/layout/ScreenContent";
import TitledHeader from "../../components/layout/TitledHeader";
import EnhancedTabSwitcher from "../../components/navigation/EnhancedTabSwitcher";
import PrimaryContentCard from "../../components/ui/PrimaryContentCard";
import AssociatedEntitiesSection from "./sections/AssociatedEntitiesSection";
import BorrowerExperienceSection from "./sections/BorrowerExperienceSection";
import ProfileBankInformationSection from "./sections/ProfileBankInformationSection";
import ProfileBorrowerInfomationSection from "./sections/ProfileBorrowerInfomationSection";
import ProfileDocumentLibrary from "./sections/ProfileDocumentLibrary";

const TABS = {
  MY_INFORMATION: "My Information",
  PRIMARY_ADDRESS: "Primary Address",
  ASSOCIATED_ENTITIES: "Associated LLC's & Entities",
  BORROWER_EXPERIENCE: "Experience",
  DOCUMENT_LIBRARY: "Document Library",
  BANK_INFORMATION: "Bank Information",
};

const ProfileScreen = () => {
  const profile = useSelector((state) => state.profile);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();
  const entities = useSelector((state) => state.profile?.associatedEntities);
  const experience = useSelector((state) => state.profile?.validatedExperience);
  const documents = useSelector((state) => state.profile?.borrowerDocuments);
  const bankAccounts = useSelector((state) => state.profile?.bankAccounts);

  const currentPath = location.pathname.split("/profile")[1] || "/";

  const TABS_LIST = [
    {
      value: "information",
      label: "My Information",
      mobileLabel: "Details",
      icon: <TextSnippetOutlined className="thin" />,
      path: "/", // Maps to /profile/
    },
    {
      value: "entities",
      label: "Associated LLC's & Entities",
      mobileLabel: "Entities",
      icon: <ApartmentOutlined className="thin" />,
      path: "/entities", // Maps to /profile/entities
      badge: {
        show: isEmpty(entities),
        variant: "dot",
        color: "error",
      },
    },
    {
      value: "experience",
      label: "Borrower Experience",
      mobileLabel: "Experience",
      icon: <HistoryOutlined className="thin" />,
      path: "/experience", // Maps to /profile/experience
      badge: {
        show: isEmpty(experience),
        variant: "dot",
        color: "error",
      },
    },
    {
      value: "files",
      label: `Document Library (${size(documents)})`,
      mobileLabel: "Documents",
      icon: <AttachFileOutlined className="thin" />,
      path: "/files", // Maps to /profile/files
      badge: {
        show: isEmpty(documents),
        variant: "dot",
        color: "error",
      },
    },
    {
      value: "banks",
      label: "Bank Information",
      mobileLabel: "Bank",
      icon: <AccountBalanceOutlined className="thin" />,
      path: "/banks", // Maps to /profile/banks
      badge: {
        show: isEmpty(bankAccounts),
        variant: "dot",
        color: "error",
      },
    },
  ];

  // useEffect(() => {
  //   if (isNil(profile)) {
  //     setTimeout(() => {
  //       dispatch(profileSet(profile));
  //     }, 100);
  //   } else {
  //     setInitialValues(profile);
  //   }
  // }, [profile]);

  // Don't render form until profile data is loaded
  if (!profile) {
    return (
      <Screen>
        <TitledHeader title={"Profile"} />
        <ScreenContent>
          <Txt>Loading profile...</Txt>
        </ScreenContent>
      </Screen>
    );
  }

  return (
    <Screen background="#ffffff">
      {/* <TitledHeader title={"Profile"} /> */}
      <Box
        sx={{
          p: 0,
          height: "100%",
          width: "100%",
          overflow: "hidden",
          display: "flex",
          backgroundColor: "#f5f8fa",
          flexDirection: isMobile ? "column" : "row",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            py: 2,
            overflowX: "hidden",
            overflowY: "auto",
            height: isMobile ? "calc(100% - 80px)" : "100%",
            minHeight: 0,
          }}
        >
          <ScreenContent
            maxWidth={"lg"}
            sx={{
              width: "100%",
              pb: 14,
              pt: isMobile ? 1 : 5,
              px: isMobile ? 0 : 5,
              margin: "0px auto",
            }}
          >
            <PrimaryContentCard
              subTitle={
                "Manage your personal info, entities, documents, bank details, and experience records."
              }
              title={"My Profile"}
            >
              <EnhancedTabSwitcher
                value={currentPath}
                tabs={TABS_LIST}
                useRouting // Enable routing
                basePath="/profile" // Base path for all tabs
                orientation="horizontal"
                wrap
              />

              <Routes>
                <Route
                  path="/"
                  element={<ProfileBorrowerInfomationSection />}
                />
                <Route
                  path="/entities"
                  element={<AssociatedEntitiesSection />}
                />
                <Route
                  path="/experience"
                  element={<BorrowerExperienceSection />}
                />
                <Route path="/files" element={<ProfileDocumentLibrary />} />
                <Route
                  path="/banks"
                  element={<ProfileBankInformationSection />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </PrimaryContentCard>
          </ScreenContent>
        </Box>
      </Box>
    </Screen>
  );
};

export default ProfileScreen;
// import {
//   AccountBalanceOutlined,
//   ApartmentOutlined,
//   AttachFileOutlined,
//   CheckCircleOutline,
//   ExpandMoreOutlined,
//   HistoryOutlined,
//   PersonOutline,
//   TextSnippetOutlined,
// } from "@mui/icons-material";
// import { Avatar, Box, Chip, useMediaQuery, useTheme } from "@mui/material";
// import { blue, green, grey, orange } from "@mui/material/colors";
// import { isEmpty, size } from "lodash";
// import { useMemo } from "react";
// import { useSelector } from "react-redux";
// import {
//   Navigate,
//   Route,
//   Routes,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";
// import Flx from "../../components/layout/Flx";
// import Screen from "../../components/layout/Screen";
// import ScreenContent from "../../components/layout/ScreenContent";
// import TitledHeader from "../../components/layout/TitledHeader";
// import Txt from "../../components/typography/Txt";
// import AssociatedEntitiesSection from "./sections/AssociatedEntitiesSection";
// import BorrowerExperienceSection from "./sections/BorrowerExperienceSection";
// import ProfileBankInformationSection from "./sections/ProfileBankInformationSection";
// import ProfileBorrowerInfomationSection from "./sections/ProfileBorrowerInfomationSection";
// import ProfileDocumentLibrary from "./sections/ProfileDocumentLibrary";

// // ─────────────────────────────────────────────────────────────────────────
// // Profile completion helper
// // ─────────────────────────────────────────────────────────────────────────
// const useProfileCompletion = () => {
//   const profile = useSelector((state) => state.profile);
//   const entities = profile?.associatedEntities;
//   const experience = profile?.validatedExperience;
//   const documents = profile?.borrowerDocuments;
//   const bankAccounts = profile?.bankAccounts;

//   return useMemo(() => {
//     let completed = 0;
//     const total = 5;

//     if (profile?.firstName && profile?.lastName) completed++;
//     if (!isEmpty(entities)) completed++;
//     if (!isEmpty(experience)) completed++;
//     if (!isEmpty(documents)) completed++;
//     if (!isEmpty(bankAccounts)) completed++;

//     return {
//       completed,
//       total,
//       percent: Math.round((completed / total) * 100),
//     };
//   }, [profile, entities, experience, documents, bankAccounts]);
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Profile summary card
// // ─────────────────────────────────────────────────────────────────────────
// const ProfileSummaryCard = () => {
//   const profile = useSelector((state) => state.profile);
//   const completion = useProfileCompletion();

//   const initials = useMemo(() => {
//     const first = profile?.firstName?.[0] || "";
//     const last = profile?.lastName?.[0] || "";
//     return `${first}${last}`.toUpperCase();
//   }, [profile?.firstName, profile?.lastName]);

//   const fullName = useMemo(() => {
//     return [profile?.firstName, profile?.lastName].filter(Boolean).join(" ");
//   }, [profile?.firstName, profile?.lastName]);

//   return (
//     <Box
//       sx={{
//         background: "#ffffff",
//         border: `1px solid ${grey[200]}`,
//         borderRadius: "12px",
//         p: 2.5,
//         display: "flex",
//         alignItems: "center",
//         gap: 2.5,
//         mb: 2,
//         boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//       }}
//     >
//       <Avatar
//         sx={{
//           width: 56,
//           height: 56,
//           background: `linear-gradient(135deg, ${blue[600]}, ${blue[400]})`,
//           fontSize: "20px",
//           fontWeight: 700,
//           boxShadow: `0 3px 12px ${blue[100]}`,
//         }}
//       >
//         {initials}
//       </Avatar>

//       <Flx column sx={{ flex: 1, minWidth: 0 }}>
//         <Txt bold sx={{ fontSize: "18px", lineHeight: 1.3 }}>
//           {fullName}
//         </Txt>
//         <Txt secondary sx={{ fontSize: "13px" }}>
//           {profile?.emailAddress}
//         </Txt>
//         {completion.percent === 100 && (
//           <Chip
//             icon={<CheckCircleOutline sx={{ fontSize: "14px !important" }} />}
//             label="Profile Complete"
//             size="small"
//             sx={{
//               mt: 0.6,
//               width: "fit-content",
//               height: "22px",
//               fontSize: "11px",
//               fontWeight: 600,
//               background: green[50],
//               color: green[700],
//               "& .MuiChip-icon": { color: green[600] },
//             }}
//           />
//         )}
//       </Flx>

//       {/* Completion indicator */}
//       <Flx column ac sx={{ minWidth: 70 }}>
//         <Box
//           sx={{
//             width: 48,
//             height: 48,
//             borderRadius: "50%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: completion.percent === 100 ? green[50] : grey[100],
//             border: `3px solid ${
//               completion.percent === 100 ? green[400] : blue[400]
//             }`,
//             transition: "all 0.3s ease",
//           }}
//         >
//           <Txt
//             bold
//             sx={{
//               fontSize: "13px",
//               color: completion.percent === 100 ? green[700] : blue[700],
//             }}
//           >
//             {completion.percent}%
//           </Txt>
//         </Box>
//         <Txt secondary sx={{ fontSize: "10px", mt: 0.5 }}>
//           Complete
//         </Txt>
//       </Flx>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Accordion nav item (collapsed header)
// // ─────────────────────────────────────────────────────────────────────────
// const AccordionNavItem = ({
//   icon,
//   label,
//   sublabel,
//   isActive,
//   onClick,
//   badgeShow,
//   iconBg,
//   iconColor,
// }) => {
//   return (
//     <Box
//       onClick={onClick}
//       sx={{
//         background: "#ffffff",
//         border: `1px solid ${isActive ? blue[200] : grey[200]}`,
//         borderRadius: isActive ? "12px 12px 0 0" : "12px",
//         borderBottom: isActive ? "none" : `1px solid ${grey[200]}`,
//         p: "13px 18px",
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         cursor: "pointer",
//         transition: "all 0.15s ease",
//         boxShadow: isActive
//           ? "0 1px 4px rgba(0,0,0,0.05)"
//           : "0 1px 2px rgba(0,0,0,0.03)",
//         "&:hover": {
//           background: isActive ? "#ffffff" : grey[50],
//           borderColor: isActive ? blue[200] : grey[300],
//         },
//       }}
//     >
//       <Flx ac g={1.5}>
//         {/* Icon badge */}
//         <Box
//           sx={{
//             width: 34,
//             height: 34,
//             borderRadius: "8px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: isActive ? iconBg || blue[50] : grey[100],
//             color: isActive ? iconColor || blue[600] : grey[500],
//             transition: "all 0.15s ease",
//             "& .MuiSvgIcon-root": { fontSize: "18px" },
//           }}
//         >
//           {icon}
//         </Box>

//         {/* Label / sublabel */}
//         <Flx column>
//           <Flx ac g={0.8}>
//             <Txt
//               sx={{
//                 fontSize: "14px",
//                 fontWeight: isActive ? 600 : 500,
//                 color: isActive ? grey[900] : grey[700],
//                 transition: "all 0.15s ease",
//               }}
//             >
//               {label}
//             </Txt>
//             {badgeShow && (
//               <Box
//                 sx={{
//                   width: 7,
//                   height: 7,
//                   borderRadius: "50%",
//                   background: orange[500],
//                   flexShrink: 0,
//                 }}
//               />
//             )}
//           </Flx>
//           {sublabel && (
//             <Txt sx={{ fontSize: "11px", color: grey[500] }}>{sublabel}</Txt>
//           )}
//         </Flx>
//       </Flx>

//       {/* Chevron */}
//       <ExpandMoreOutlined
//         sx={{
//           color: grey[400],
//           transition: "transform 0.2s ease",
//           transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
//         }}
//       />
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Accordion body wrapper (open panel)
// // ─────────────────────────────────────────────────────────────────────────
// const AccordionBody = ({ children }) => {
//   return (
//     <Box
//       sx={{
//         background: "#ffffff",
//         border: `1px solid ${blue[200]}`,
//         borderTop: "none",
//         borderRadius: "0 0 12px 12px",
//         p: { xs: 2, md: 3 },
//         boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//         animation: "profileAccordionIn 0.25s ease",
//         "@keyframes profileAccordionIn": {
//           from: { opacity: 0, transform: "translateY(-4px)" },
//           to: { opacity: 1, transform: "translateY(0)" },
//         },
//       }}
//     >
//       {children}
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Main ProfileScreen
// // ─────────────────────────────────────────────────────────────────────────
// const ProfileScreen = () => {
//   const profile = useSelector((state) => state.profile);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const location = useLocation();
//   const navigate = useNavigate();

//   const entities = useSelector((state) => state.profile?.associatedEntities);
//   const experience = useSelector((state) => state.profile?.validatedExperience);
//   const documents = useSelector((state) => state.profile?.borrowerDocuments);
//   const bankAccounts = useSelector((state) => state.profile?.bankAccounts);

//   const currentPath = location.pathname.split("/profile")[1] || "/";

//   // ── Accordion config ──────────────────────────────────────────────
//   const SECTIONS = useMemo(
//     () => [
//       {
//         path: "/",
//         label: "Personal Information",
//         sublabel: "Contact and identity details",
//         icon: <PersonOutline className="thin" />,
//         iconBg: blue[50],
//         iconColor: blue[600],
//         badgeShow: false,
//         component: <ProfileBorrowerInfomationSection />,
//       },
//       {
//         path: "/entities",
//         label: "Entities",
//         sublabel: `${size(entities) || 0} registered`,
//         icon: <ApartmentOutlined className="thin" />,
//         iconBg: green[50],
//         iconColor: green[600],
//         badgeShow: isEmpty(entities),
//         component: <AssociatedEntitiesSection />,
//       },
//       {
//         path: "/experience",
//         label: "Borrower Experience",
//         sublabel: `${size(experience) || 0} records`,
//         icon: <HistoryOutlined className="thin" />,
//         iconBg: orange[50],
//         iconColor: orange[700],
//         badgeShow: isEmpty(experience),
//         component: <BorrowerExperienceSection />,
//       },
//       {
//         path: "/files",
//         label: "Document Library",
//         sublabel: `${size(documents) || 0} files uploaded`,
//         icon: <AttachFileOutlined className="thin" />,
//         iconBg: "#FEF3C7",
//         iconColor: "#D97706",
//         badgeShow: isEmpty(documents),
//         component: <ProfileDocumentLibrary />,
//       },
//       {
//         path: "/banks",
//         label: "Bank Information",
//         sublabel: `${size(bankAccounts) || 0} linked`,
//         icon: <AccountBalanceOutlined className="thin" />,
//         iconBg: blue[50],
//         iconColor: blue[700],
//         badgeShow: isEmpty(bankAccounts),
//         component: <ProfileBankInformationSection />,
//       },
//     ],
//     [entities, experience, documents, bankAccounts],
//   );

//   const handleSectionClick = (path) => {
//     if (currentPath === path) return; // Already active
//     navigate(`/profile${path}`);
//   };

//   // ── Loading state ─────────────────────────────────────────────────
//   if (!profile) {
//     return (
//       <Screen>
//         <TitledHeader title={"Profile"} />
//         <ScreenContent>
//           <Txt>Loading profile...</Txt>
//         </ScreenContent>
//       </Screen>
//     );
//   }

//   return (
//     <Screen background="#f5f5f2">
//       <TitledHeader title={"Profile"} />
//       <Box
//         sx={{
//           p: 0,
//           height: "100%",
//           width: "100%",
//           overflow: "hidden",
//           display: "flex",
//           backgroundColor: "#f5f5f2",
//           flexDirection: isMobile ? "column" : "row",
//           position: "relative",
//         }}
//       >
//         <Box
//           sx={{
//             flexGrow: 1,
//             py: 1.4,
//             overflowX: "hidden",
//             overflowY: "auto",
//             height: isMobile ? "calc(100% - 80px)" : "100%",
//             minHeight: 0,
//           }}
//         >
//           <ScreenContent
//             maxWidth="md"
//             sx={{
//               width: "100%",
//               pb: 14,
//               px: isMobile ? 1.5 : 4,
//               margin: "0px auto",
//             }}
//           >
//             {/* Profile summary */}
//             <ProfileSummaryCard />

//             {/* Accordion-style navigation + content */}
//             <Flx column g={1}>
//               {SECTIONS.map((section) => {
//                 const isActive = currentPath === section.path;

//                 return (
//                   <Box key={section.path}>
//                     <AccordionNavItem
//                       icon={section.icon}
//                       label={section.label}
//                       sublabel={section.sublabel}
//                       isActive={isActive}
//                       onClick={() => handleSectionClick(section.path)}
//                       badgeShow={section.badgeShow}
//                       iconBg={section.iconBg}
//                       iconColor={section.iconColor}
//                     />
//                     {isActive && (
//                       <AccordionBody>{section.component}</AccordionBody>
//                     )}
//                   </Box>
//                 );
//               })}
//             </Flx>
//           </ScreenContent>
//         </Box>
//       </Box>
//     </Screen>
//   );
// };

// export default ProfileScreen;
// ----------------------------------------------
// ----------------------------------------------
// ----------------------------------------------
// import {
//   AccountBalanceOutlined,
//   ApartmentOutlined,
//   AttachFileOutlined,
//   HistoryOutlined,
//   TextSnippetOutlined,
// } from "@mui/icons-material";
// import { Box, useMediaQuery, useTheme } from "@mui/material";

// import { isEmpty, over, size } from "lodash";
// import { useSelector } from "react-redux";
// import Txt from "../../components/typography/Txt";

// import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import Screen from "../../components/layout/Screen";
// import ScreenContent from "../../components/layout/ScreenContent";
// import TitledHeader from "../../components/layout/TitledHeader";
// import EnhancedTabSwitcher from "../../components/navigation/EnhancedTabSwitcher";
// import PrimaryContentCard, {
//   CardPaper,
// } from "../../components/ui/PrimaryContentCard";
// import AssociatedEntitiesSection from "./sections/AssociatedEntitiesSection";
// import BorrowerExperienceSection from "./sections/BorrowerExperienceSection";
// import ProfileBankInformationSection from "./sections/ProfileBankInformationSection";
// import ProfileBorrowerInfomationSection from "./sections/ProfileBorrowerInfomationSection";
// import ProfileDocumentLibrary from "./sections/ProfileDocumentLibrary";
// import Flx from "../../components/layout/Flx";
// import { useMemo } from "react";
// import { blue, green, grey } from "@mui/material/colors";
// import Htag from "../../components/typography/Htag";

// const ProfileScreen = () => {
//   const profile = useSelector((state) => state.profile);
//   const theme = useTheme();
//   // const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const location = useLocation();
//   const entities = useSelector((state) => state.profile?.associatedEntities);
//   const experience = useSelector((state) => state.profile?.validatedExperience);
//   const documents = useSelector((state) => state.profile?.borrowerDocuments);
//   const bankAccounts = useSelector((state) => state.profile?.bankAccounts);
//   const isMobile = useMediaQuery("(max-width:768px)");
//   const currentPath = location.pathname.split("/profile")[1] || "/";
//   const completion = useProfileCompletion();
//   const TABS_LIST = [
//     {
//       value: "information",
//       label: "My Information",
//       mobileLabel: "Details",
//       icon: <TextSnippetOutlined className="thin" />,
//       path: "/", // Maps to /profile/
//     },
//     {
//       value: "entities",
//       label: "Associated LLC's & Entities",
//       mobileLabel: "Entities",
//       icon: <ApartmentOutlined className="thin" />,
//       path: "/entities", // Maps to /profile/entities
//       badge: {
//         show: isEmpty(entities),
//         variant: "dot",
//         color: "error",
//       },
//     },
//     {
//       value: "experience",
//       label: "Borrower Experience",
//       mobileLabel: "Experience",
//       icon: <HistoryOutlined className="thin" />,
//       path: "/experience", // Maps to /profile/experience
//       badge: {
//         show: isEmpty(experience),
//         variant: "dot",
//         color: "error",
//       },
//     },
//     {
//       value: "files",
//       label: `Document Library (${size(documents)})`,
//       mobileLabel: "Documents",
//       icon: <AttachFileOutlined className="thin" />,
//       path: "/files", // Maps to /profile/files
//       badge: {
//         show: isEmpty(documents),
//         variant: "dot",
//         color: "error",
//       },
//     },
//     {
//       value: "banks",
//       label: "Bank Information",
//       mobileLabel: "Bank",
//       icon: <AccountBalanceOutlined className="thin" />,
//       path: "/banks", // Maps to /profile/banks
//       badge: {
//         show: isEmpty(bankAccounts),
//         variant: "dot",
//         color: "error",
//       },
//     },
//   ];

//   // Don't render form until profile data is loaded
//   if (!profile) {
//     return (
//       <Screen>
//         <TitledHeader title={"Profile"} />
//         <ScreenContent>
//           <Txt>Loading profile...</Txt>
//         </ScreenContent>
//       </Screen>
//     );
//   }

//   return (
//     <Screen background="#f5f8fa">
//       {/* <TitledHeader title={"Profile"} /> */}
//       <ScreenContent
//         maxWidth={"xl"}
//         sx={{
//           width: "100%",
//           pb: 14,
//           pt: 3,
//           px: isMobile ? 0 : 5,
//           margin: "0px auto",
//           height: "100%",
//         }}
//       >
//         <Flx fw jb ac wrap>
//           <Flx column>
//             <Htag>My Profile</Htag>
//             <Txt>
//               Manage your personal info, entities, documents, bank details, and
//               experience records.
//             </Txt>
//           </Flx>
//           <Flx g={1} ac sx={{ minWidth: 70 }}>
//             <Txt secondary sx={{}}>
//               Profile Completion
//             </Txt>
//             <Box
//               sx={{
//                 width: 48,
//                 height: 48,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: completion.percent === 100 ? green[50] : grey[100],
//                 border: `3px solid ${
//                   completion.percent === 100 ? green[400] : blue[400]
//                 }`,
//                 transition: "all 0.3s ease",
//               }}
//             >
//               <Txt
//                 bold
//                 sx={{
//                   fontSize: "13px",
//                   color: completion.percent === 100 ? green[700] : blue[700],
//                 }}
//               >
//                 {completion.percent}%
//               </Txt>
//             </Box>
//           </Flx>
//         </Flx>

//         <Flx wrap g={2} sx={{ mt: 2, overflow: "hidden", height: "100%" }}>
//           <CardPaper
//             sx={{
//               p: 1,
//               m: 0,
//               flexGrow: 1,
//               flexShrink: 0,
//               flexDirection: "row",
//               flexBasis: "200px",
//             }}
//           >
//             <EnhancedTabSwitcher
//               value={currentPath}
//               tabs={TABS_LIST}
//               useRouting // Enable routing
//               basePath="/profile" // Base path for all tabs
//               orientation={isMobile ? "horizontal" : "vertical"}
//               wrap
//             />
//           </CardPaper>

//           <CardPaper
//             sx={{
//               m: 0,
//               flexDirection: "row",
//               py: 0,
//               flexBasis: "980px",
//               flexGrow: 1,
//               flexShrink: 1,
//             }}
//           >
//             <Flx column fw>
//               <Routes>
//                 <Route
//                   path="/"
//                   element={<ProfileBorrowerInfomationSection />}
//                 />
//                 <Route
//                   path="/entities"
//                   element={<AssociatedEntitiesSection />}
//                 />
//                 <Route
//                   path="/experience"
//                   element={<BorrowerExperienceSection />}
//                 />
//                 <Route path="/files" element={<ProfileDocumentLibrary />} />
//                 <Route
//                   path="/banks"
//                   element={<ProfileBankInformationSection />}
//                 />
//                 <Route path="*" element={<Navigate to="/" replace />} />
//               </Routes>
//             </Flx>
//           </CardPaper>
//         </Flx>
//       </ScreenContent>

//     </Screen>
//   );
// };
// const useProfileCompletion = () => {
//   const profile = useSelector((state) => state.profile);
//   const entities = profile?.associatedEntities;
//   const experience = profile?.validatedExperience;
//   const documents = profile?.borrowerDocuments;
//   const bankAccounts = profile?.bankAccounts;

//   return useMemo(() => {
//     let completed = 0;
//     const total = 5;

//     if (profile?.firstName && profile?.lastName) completed++;
//     if (!isEmpty(entities)) completed++;
//     if (!isEmpty(experience)) completed++;
//     if (!isEmpty(documents)) completed++;
//     if (!isEmpty(bankAccounts)) completed++;

//     return {
//       completed,
//       total,
//       percent: Math.round((completed / total) * 100),
//     };
//   }, [profile, entities, experience, documents, bankAccounts]);
// };
// export default ProfileScreen;
